<template>
  <div class="app-main">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  components: {
    
  },
  props: {
    
  },
  data: () => ({
    
  }),
  computed: {
    
  },
  watch: {
    
  },
  methods: {
    
  },
  created() {
    
  },
}
</script>

<style lang="scss" scoped>
.app-main {
  width: 100%;
  padding: 16px;
  background-color: $bg-normal;
}
</style>